import { SkeletonItemListComponent } from './components/skeleton-list-item/skeleton-list-item.component';
import { CustomLoaderComponent } from './components/custom-loader/custom-loader.component';
import { SystemInfoService } from './services/system-info/system-info.service';
import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { AppNavigationComponent } from './components/app-navigation/app-navigation.component';
import { ChatMessengerComponent } from './components/chat-messenger/chat-messenger.component';
import { LoadingScreenService } from './services/loading-screen/loading-screen.service';
import { RouterModule } from '@angular/router';
import { ChatMessageService } from './services/chat-mesage/chat-message.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EnrolledUnitService } from './services/enrolled-unit.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { QuoteFormService } from './services/quote-form/quote-form.service';
import { EsppQuoterModule } from '../modules/espp/modules/espp-quoter/espp-quoter.module';
import { EsppQuoterComponent } from '../modules/espp/modules/espp-quoter/espp-quoter.component';
import { EpgDialogModule } from '../modules/epg-dialog/epg-dialog.module';
import { MaterialModule } from './material.module';
import { ShortDatePipe } from './pipes/short-date/short-date.pipe';
import { QueueLandingIconComponent } from './components/queue-landing-icon/queue-landing-icon.component';
import { EpgDialogComponent } from './components/epg-dialog/epg-dialog.component';
import { EpgDialogService } from './components/epg-dialog/epg-dialog.service';
import { EpgDatePipe } from './pipes/epg-date.pipe';
import { EpgCurrencyPipe } from './pipes/epg-currency.pipe';
import { DebugPanelComponent } from './components/debug-panel/debug-panel.component';
import { ErrorMessageDirective } from './directives/error-message.directive';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OrderByPipe } from './pipes/order-by.pipe';
import {MatChipsModule} from '@angular/material/chips';
import { HideIfUnauthorizedDirective } from '../core/directives/authorization/hide-if-unauthorized.directive';
import { ToastNotificationService} from './services/toast-notification/toast-notification.service';
import { ToastComponent } from './services/toast-notification/toast-component/toast.component';
import { DownloadPDFComponent, DownloadPDFService } from './services/download-pdf';
import { UserProfileComponent } from './components/user-profile';
import { HighlightedMessageModule } from './components/highlighted-message';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { FeatureFlagModule } from './feature-flag.module';



const MatModules = [
    MatSnackBarModule,
    MatDialogModule,
    MatSidenavModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSelectModule,
    MatRadioModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatCardModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatChipsModule,
];
@NgModule({
  declarations: [UserProfileComponent, SkeletonItemListComponent, DownloadPDFComponent, ToastComponent, HideIfUnauthorizedDirective, CookieConsentComponent, LoadingScreenComponent, CustomLoaderComponent, ChatMessengerComponent, AppNavigationComponent, ShortDatePipe,EpgDatePipe, EpgCurrencyPipe, QueueLandingIconComponent, EpgDialogComponent,DebugPanelComponent,ErrorMessageDirective,ContactUsComponent, OrderByPipe],
  imports: [
    NgxMaskDirective,
    NgcCookieConsentModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    EsppQuoterModule,
    EpgDialogModule,
    MaterialModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    HighlightedMessageModule,
    FeatureFlagModule,

  ],
  exports: [SkeletonItemListComponent, DownloadPDFComponent, ToastComponent, HideIfUnauthorizedDirective, CookieConsentComponent, LoadingScreenComponent, CustomLoaderComponent,ChatMessengerComponent,AppNavigationComponent,EsppQuoterComponent,...MatModules, ShortDatePipe,QueueLandingIconComponent,EpgDialogComponent,EpgDatePipe,EpgCurrencyPipe,DebugPanelComponent,ErrorMessageDirective,ContactUsComponent, OrderByPipe, FeatureFlagModule,],
  providers: [provideNgxMask(), SystemInfoService, DownloadPDFService, ToastNotificationService, LoadingScreenService, ChatMessageService, EnrolledUnitService,QuoteFormService,DatePipe, CurrencyPipe, EpgDialogService],
})
export class SharedModule { }